export default {
  path: '/c/:referralKey?/:email?/:dateOfBirth?/:zipCode?/:accept?',
  async action(...args) {
    return (await import('./loader')).default(...args);
  },
};
